/**
 * Grooming constants (epic PI-SPEC-SW-E279).
 *
 * Single source of truth for the limits the API, the batch engine, the web
 * pages and SpecTree Toolbox share. Import these; never re-type the numbers
 * (the 20-item batch cap in particular is enforced in several places).
 * `@spectree/shared` re-exports this module, so SpecTree code may import
 * them from either package; the definitions live only here.
 */
/** Most items one grooming batch (session agenda or run) may hold. */
export const MAX_GROOMING_BATCH_ITEMS = 20;
/** How many backlog items the "top of the backlog" view shows by default. */
export const BACKLOG_TOP_DEFAULT = 30;
/** Hard ceiling on items returned when the user asks for the whole backlog. */
export const BACKLOG_ALL_MAX = 500;
/** Tag that marks an item for the next grooming run ("tagged" batch mode). */
export const DEFAULT_GROOM_TAG = "groom-next";
/** Claude Code model alias the batch engine runs when a project sets none. */
export const DEFAULT_GROOMING_MODEL = "opus";
/** Most repositories one project's grooming config may map. */
export const MAX_GROOMING_REPOS = 10;
/** Most product areas (archived ones excluded) one project may define. */
export const MAX_PRODUCT_AREAS = 60;
/** Number of past sprints the pace (velocity) view averages over. */
export const PACE_SPRINTS = 3;
/**
 * Longest plain activity line an `item-progress` event may carry (contract 2).
 * The engine trims longer phrases before sending.
 */
export const GROOMING_ACTIVITY_MAX_CHARS = 140;
/** Typical-time hint shown beside a run's elapsed timer when no recent runs exist. */
export const GROOMING_TYPICAL_RUN_FALLBACK = "usually 3–5 min";
//# sourceMappingURL=constants.js.map